import React from 'react';

export interface iFrameProps {
  src?: string;
  style?: Record<string, string>;
  title?: string;
}

export const Iframe: React.FC<iFrameProps> = ({
  src = 'https://www.youtube.com/embed/pT3bUQixLxQ?title=0&portrait=0&byline=0&autoplay=1&muted=true&controls=0&&showinfo=0&loop=1',
  style = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: '50% 50%',
  },
  title = '',
}) => {
  return <iframe title={title} src={src} autoFocus style={style} />;
};
